import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import FloatAccess from '../../atoms/float-access/float-access';
import OptionsRedirect from '../../molecules/options-redirect/options-redirect';
import Footer from '../footer/footer';
import Header from '../header/header';
import MenuMobile from '../menu-mobile/menu-mobile';
import ModalPrehome from '../modal-prehome/modal-prehome';
import './layout.scss';

const Layout = props => {
    const { children, segmentActive } = props;

    const [mobileMenuActive, setmobileMenuActive] = useState(false);
    const [showingPrehomeAccess, setshowingPrehomeAccess] = useState(false);
    const [activeModal, setactiveModal] = useState(null)

    const dateAccess = '2022/08/19'
    const dateAutoShow = '2022/06/18'
    const dateInitial = '2022/05/18'

    useEffect(() => {
        handleShowPrehomeAccess();
        handleAutoModal();
    }, [])



    const handleShowPrehomeAccess = () => {
        //let isHome = window.location.pathname === '/';
        let today = new Date();
        let finalDay = new Date(dateAccess);
        let initial = new Date(dateInitial);

        /*if (today < finalDay && today >= initial && isHome) {
            setshowingPrehomeAccess(true);
        }*/
        if (today < finalDay && today >= initial ) {
            setshowingPrehomeAccess(true);
        }
    }

    const handleAutoModal = () => {
        //let isHome = window.location.pathname === '/';
        let today = new Date();
        let finalDay = new Date(dateAutoShow);
        let initial = new Date(dateInitial);
        let modalshowed = localStorage.getItem('phs')

        /*if (today < finalDay && today >= initial && isHome && !modalshowed) {
            handleShowPrehome(true);
            localStorage.setItem('phs', today) //phs = prehome showed
        }*/
        if (today < finalDay && today >= initial && !modalshowed) {
            handleShowPrehome(true);
            localStorage.setItem('phs', today) //phs = prehome showed
        }
    }

    const handleShowPrehome = () => {
        document.getElementsByTagName('html')[0].style.overflow = "hidden";
        setactiveModal(
            <ModalPrehome
                setactiveModal={setactiveModal}
                closePrehome={hanldeClosePrehome}
            />
        )
    }

    const hanldeClosePrehome = () => {
        document.getElementsByTagName('html')[0].style.overflow = "";
        setactiveModal(null)
    }


    return (
        <>
            <Helmet
                script={[{
                    type: 'text/javascript',
                    innerHTML: `
                        if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
                            window.location = 'microsoft-edge:' + window.location;
                            setTimeout(function () {
                                window.location = 'https://go.microsoft.com/fwlink/?linkid=2135547';
                            }, 1);
                        }
						var __dcid = __dcid || [];__dcid.push(["DigiCertClickID_8bIGQRbh", "3", "m", "black", "8bIGQRbh"]);
                        (function(){
                            var cid=document.createElement("script");
                            cid.async=true;
                            cid.src="//seal.digicert.com/seals/cascade/seal.min.js";
                            var s = document.getElementsByTagName("script");
                            var ls = s[(s.length - 1)];
                            ls.parentNode.insertBefore(cid, ls.nextSibling);
                        }());

                        (function () {
                            if (window.location.host.match(/(?![a-z0-9-].*?\.)?(${process.env.SITE_URL_SCRIPT})$/) === null) {
                                var tag = document.createElement('script');
                                tag.type = 'text/javascript';
                                tag.async = true;
                                tag.innerHTML = "(function(){ (new Image()).src = '//images-cdn.info/502/image.gif'; })();";
                                var first = document.getElementsByTagName('script')[0];
                                first.parentNode.insertBefore(tag, first);
                            }
                            const tags = document.querySelectorAll('[data-react-helmet]')
                            tags.forEach(e => e.removeAttribute('data-react-helmet'))
                            const tagsDataProtocol = document.querySelectorAll('[data-baseprotocol]')
                            const tagsDataHost= document.querySelectorAll('[data-basehost]')                           
                            tagsDataProtocol.forEach(e => e.removeAttribute('data-baseprotocol'))
                            tagsDataHost.forEach(e => e.removeAttribute('data-basehost'))                
                        })();                       
                    `
                }]}
            />
            {activeModal}
            <Header
                segmentActive={segmentActive}
                mobileMenuActive={mobileMenuActive}
                setmobileMenuActive={setmobileMenuActive}
                showingPrehomeAccess={showingPrehomeAccess}
                setshowingPrehomeAccess={setshowingPrehomeAccess}
                showPrehome={handleShowPrehome}
            />
            {mobileMenuActive &&
                <MenuMobile
                    setmobileMenuActive={setmobileMenuActive}
                />
            }
            <div className={"o-main-container " + (showingPrehomeAccess ? 'showing-prehome' : '')}>
                {children}
            </div>

            <FloatAccess />
            {process.env.ENVIRONMENT !== 'production' && <span className="f-env-watermark">{process.env.ENVIRONMENT}</span>}

            <Footer />
        </>
    )
}

export default Layout;
